<template>
  <div class="container">
    <!-- 视频 -->
    <div class="pageBox_video">
      <video
        id="videoIndex"
        class="videoBox"
        ref="videoPlay"
        :src="video_src"
        muted
        controls="controls"
        style="object-fit: cover"
        autoplay
      >
        您的浏览器不支持视频播放
      </video>
    </div>
    <!-- 轮播图 -->
    <div class="lunboBg">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="22" :sm="22" :md="18">
          <div class="swiperBox">
            <!-- 标题 -->
            <div class="indexTitle">
              <div class="indexTitle_text">{{ $t("home.title1") }}</div>
            </div>
            <!--  -->
            <div class="Rotation">
              <swiper ref="mySwiper" :options="swiperOption">
                <swiper-slide
                  class="swip"
                  v-for="item in bannerData"
                  :key="item.id"
                >
                  <img
                    width="100%"
                    height="100%"
                    :src="item.pic"
                    alt=""
                    @click="goDetailPage(item.source_id)"
                  />
                </swiper-slide>

                <!-- 分页器 -->
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
            <!-- 轮播图 -->
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 党建要闻 不在这里显示-->
    <el-row :gutter="0" type="flex" justify="center">
      <el-col :xs="22" :sm="22" :md="18">
        <div hidden class="newsBox">
          <!-- 标题 -->
          <!-- <div class="indexTitle">
            <div class="indexTitle_text">{{ $t("home.title2") }}</div>
            <div class="indexTitle_more" @click="goPartyBuildingPage()">
              {{ $t("home.title2_more") }}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="newsListBox">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="16" :md="16">
                <div class="newsList_Left">
                  <div
                    class="newsList"
                    v-for="(item, index) in newsData"
                    v-if="index < 8"
                    :key="index"
                    @click="goPartyBuildingDetail(item.id)"
                  >
                    <el-col :xs="8" :sm="7" :md="8" :lg="6" :xl="4">
                      <div class="newsDate">{{ item.create_time }}</div>
                    </el-col>
                    <el-col :xs="16" :sm="16" :md="14" :lg="16" :xl="20">
                      <div class="newsTitle">{{ item.title }}</div>
                    </el-col>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8">
                <div class="newsList_Right">
                  <div
                    class="rightNewsList"
                    v-for="(item, index) in newsData"
                    v-if="index > 8"
                    :key="index"
                    @click="goPartyBuildingDetail(item.id)"
                  >
                    <el-image class="rightNewsList_img" :src="item.pic" fit="cover">
                    </el-image>
                    <div class="rightNewsText">{{ item.title }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div> -->
        </div>
      </el-col>
    </el-row>

    <!-- 公司简介 -->
    <div class="journalismBox">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="22" :sm="22" :md="18">
          <!-- sm 及以下尺寸时隐藏  PC样式 -->
          <div class="companyTitleBox hidden-xs-only">
            <div class="indexTitle_text">{{ $t("home.title3") }}</div>
            <div class="titleBottomLine"></div>
            <div class="indexTitle_more" @click="goMoreNewsPage()">
              {{ $t("home.title3_more") }}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <!-- sm 及以上尺寸时隐藏 手机样式 -->
          <div class="indexTitle hidden-sm-and-up">
            <div class="indexTitle_text">{{ $t("home.title3") }}</div>
            <div class="indexTitle_more" @click="goMoreNewsPage()">
              {{ $t("home.title3_more") }}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </el-col>
      </el-row>
      <industryTrends ref="industryTrends"></industryTrends>
    </div>

    <!-- 组织架构 -->
    <!-- <div class="organizationalStructureBox">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="22" :sm="22" :md="18">
          <div class="companyTitleBox hidden-xs-only">
            <div class="indexTitle_text">
              {{ $t("home.organizationalStructure") }}
            </div>
            <div class="titleBottomLine"></div>
          </div>
          <div class="indexTitle hidden-sm-and-up">
            <div class="indexTitle_text">
              {{ $t("home.organizationalStructure") }}
            </div>
          </div>
        </el-col>
      </el-row>
      <articleCenter ref="articleCenter" :type="3013"></articleCenter>
    </div> -->

    <!-- 合作伙伴 -->
    <div hidden class="PartnersBox">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="22" :sm="22" :md="18">
          <!-- sm 及以下尺寸时隐藏  PC样式 -->
          <div class="companyTitleBox hidden-xs-only">
            <div class="indexTitle_text">{{ $t("home.title4") }}</div>
            <div class="titleBottomLine"></div>
          </div>
          <!-- sm 及以上尺寸时隐藏 手机样式 -->
          <div class="indexTitle hidden-sm-and-up">
            <div class="indexTitle_text">{{ $t("home.title4") }}</div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="22" :sm="22" :md="18">
          <el-row :gutter="15">
            <el-col
              :xs="8"
              :sm="4"
              :md="4"
              v-for="(item, index) in partnerData"
              :key="index"
            >
              <a :href="item.partner_url" target="_blank">
                <el-image class="partnersImg" :src="item.logo" fit="cover">
                </el-image>
              </a>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!--  -->

    <!-- 产品与服务 -->
    <div class="PartnersBox">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="22" :sm="22" :md="18">
          <!-- sm 及以下尺寸时隐藏  PC样式 -->
          <div class="companyTitleBox hidden-xs-only">
            <div class="indexTitle_text">{{ $t("route.ProductCenter") }}</div>
            <div class="titleBottomLine"></div>
            <div class="indexTitle_more" @click="goMoreProduct">
              {{ $t("home.title3_more") }}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <!-- sm 及以上尺寸时隐藏 手机样式 -->
          <div class="indexTitle hidden-sm-and-up">
            <div class="indexTitle_text">{{ $t("route.ProductCenter") }}</div>
            <div class="indexTitle_more" @click="goMoreProduct">
              {{ $t("home.title3_more") }}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </el-col>
      </el-row>
      <productCenter :home="1" ref="productCenter"></productCenter>
    </div>
    <!--  -->
  </div>
</template>

<script>
import { formatTimeNum } from "@/utils";
import * as home from "@/api/home";
import productCenter from "@/views/productCenter/productCenter";
import industryTrends from "@/views/newsInformation/newsItem/industryTrends";
import { localStorage } from "@/utils/storage";
import articleCenter from "@/views/pilotService/articleCenter/articleCenter";

export default {
  components: { productCenter, industryTrends, articleCenter },
  name: "Home",
  data() {
    return {
      video_src: "",
      swiperOption: {
        //轮播图配置
        // loop: true,
        autoplay: true,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          bulletClass: "my-bullet", //需设置.my-bullet样式
          bulletActiveClass: "my-bullet-active",
        },
      },
      bannerData: [],
      // 党建新闻数据
      newsData: [],
      // 合作方数据
      partnerData: [],
    };
  },
  mounted() {
    this.getVideoData(); //获取视频
    this.getBanner();
    // this.getReadCompany(); // 获取公司概况
    // this.getNewsData(); // 获取党建要闻
    // this.getPartnerData(); //获取合作方
  },
  methods: {
    // 获取首页视频
    getVideoData() {
      home
        .getvideo()
        .then((response) => {
          if (response.code == 0) {
            this.video_src = response.data.homepage_video_url;
          }
        })
        .catch((res) => {
          ;
        });
    },
    getBanner() {
      home
        .banner_read({ banner_type: 2 })
        .then((res) => {
          if (res.code === 0) {
            this.bannerData = res.data.data;
          }
        })
        .catch((err) => {
          ;
        });
    },
    // 获取公司概况
    getReadCompany() {
      home
        .readCompany()
        .then((response) => {
          if (response.code == 0) {
            ;
          }
        })
        .catch((res) => {
          ;
        });
    },
    goDetailPage(id) {
      this.$router.push({ path: "/newsDetail", query: { id: id } });
    },
    // 获取党建要闻
    getNewsData() {
      home
        .party_building()
        .then((res) => {
          if (res.code == 0) {
            let data = res.data.data;
            for (let item of data) {
              item.create_time = formatTimeNum(item.create_time, "Y年M月D日");
            }
            this.newsData = data;
          }
        })
        .catch((res) => {
          ;
        });
    },
    // 获取合作方数据
    getPartnerData() {
      home
        .partner()
        .then((res) => {
          if (res.code == 0) {
            let data = res.data.data;
            this.partnerData = data;
          }
        })
        .catch((res) => {
          ;
        });
    },

    // 查看新闻信息
    goMoreNewsPage() {
      // localStorage.set("menu", '/newsInformation');
      this.$router.push({ path: "/newsInformation" });
    },
    goMoreProduct() {
      this.$router.push({ path: "/product" });
    },
    // 查看党建要闻
    goPartyBuildingPage() {
      this.$router.push({ path: "/partyBuilding" });
    },
    // 查看党建要闻详情
    goPartyBuildingDetail(id) {
      ;
      this.$router.push({
        path: "/partyBuildingDetail",
        query: { id: id },
      });
    },
  },
};
</script>

<style scoped>
.pageBox_video {
  height: 465px;
}
.videoBox {
  width: 100% !important;
  height: 465px !important;
}
.lunboBg {
  width: 100%;
  background: url("../../assets/images/home/lunbobg.jpg") top center no-repeat;
  background-size: 100% auto;
}
.swiperBox,
.newsBox {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px 0;
  margin-bottom: 40px;
}
.swip {
  height: 60vh;
  cursor: pointer;
}
.indexTitle {
  width: 100%;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.indexTitle_text {
  font-size: 30px;
  /* color: #015a9c; */
  font-weight: bold;
}
.indexTitle_more {
  font-size: 14px;
  color: #777a83;
  cursor: pointer;
}
.newsListBox {
  width: 100%;
  border-top: 1px solid #e7e7e7;
  /* display: flex;
		align-items: center; */
  padding-top: 10px;
}
.newsList_Left {
  /* width: calc(100% - 350px); */
  width: 100%;
  margin-bottom: 10px;
}
.newsList {
  width: 100%;
  padding: 15px 0;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.newsDate {
  width: 120px;
  font-size: 14px;
  color: #787b8a;
  margin-right: 40px;
}
.newsTitle {
  /* width: calc(100% - 160px); */
  width: 100%;
  display: -webkit-box;
  overflow: hidden;
  /*! autoprefixer: off; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.newsList_Right {
  width: 100%;
}
.rightNewsList {
  width: 100%;
  margin: 30px 0;
  cursor: pointer;
}
.rightNewsList_img {
  width: 100%;
  height: 150px;
}
.rightNewsText {
  padding: 10px 0;
  font-size: 16px;
  color: #333333;
  display: -webkit-box;
  overflow: hidden;
  /*! autoprefixer: off; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.companyBox {
  width: 100%;
  padding: 20px 0 30px;
  background: url("../../assets/images/home/lunbobg.jpg") top center no-repeat;
  background-size: 100% auto;
}

.companyTitleBox {
  width: 100%;
  padding: 20px 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.companyTitleBox .indexTitle_more {
  position: absolute;
  top: 50%;
  right: 0;
  transform: rotateY(-50%);
}
.titleBottomLine {
  width: 80px;
  height: 10px;
  background: #015a9c;
  border-radius: 10px;
  margin-top: 10px;
}

.PartnersBox {
  width: 100%;
  background: #ffffff;
  padding: 20px 0 40px;
}
.partnersImg {
  width: 100%;
  height: 50px;
  margin: 5px 0;
  cursor: pointer;
}

/*  */
/* 组织架构 */
.organizationalStructureBox {
  width: 100%;
  padding: 20px 0 30px;
  background: url("../../assets/images/home/organization.jpg") top center
    no-repeat;
  background-size: 100% auto;
}
/*  */
/* 公司简介 */
.journalismBox {
  padding: 15px 0 45px;
}

/* 响应式样式 */

@media only screen and (max-width: 768px) {
  .pageBox_video {
    height: auto;
  }
  .videoBox {
    /* height: 200px; */
    height: auto !important;
  }
  .swiperBox {
    margin-bottom: 0px;
    padding: 15px 0;
  }
  .swip {
    height: auto;
  }
  .indexTitle {
    padding-bottom: 15px;
  }
  .indexTitle_text {
    font-size: 18px;
  }
  .newsBox {
    margin-bottom: 0;
  }
  .companyTitleBox {
    padding: 0 0 10px;
  }

  .rightNewsList_img {
    height: auto;
  }
  .partnersImg {
    height: 60px;
  }
  .journalismBox {
    padding: 15px 0;
  }
  .organizationalStructureBox {
    background-size: 100% 100%;
    padding: 20px 0 15px;
  }
}

@media screen and (min-width: 768px) {
  /* .videoBox {
    height: 465px;
  } */
}
@media screen and (min-width: 992px) {
}

@media screen and (min-width: 1200px) {
}

@media screen and (min-width: 1400px) {
}

@media screen and (min-width: 1920px) {
}
</style>
<style>
.el-carousel__container {
  height: 180px;
}
</style>
